"use client";

import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const reviews = [{
  id: 1,
  name: "Mark V.",
  location: "Middelharnis",
  rating: 5,
  text: "De beste fade in Goeree-Overflakkee. De aandacht voor detail is ongeëvenaard en de sfeer is altijd gastvrij. Een echte aanrader!"
}, {
  id: 2,
  name: "Johan D.",
  location: "Sommelsdijk",
  rating: 5,
  text: "Ik kom al jaren bij H&E Kappers. Altijd een geweldige ervaring, professionele barbers en elke keer weer een perfect resultaat."
}, {
  id: 3,
  name: "Peter S.",
  location: "Dirksland",
  rating: 5,
  text: "Professioneel, snel en precies wat ik wilde. De hot towel shave is een absolute aanrader voor elke man die wil ontspannen."
}, {
  id: 4,
  name: "Thomas B.",
  location: "Middelharnis",
  rating: 5,
  text: "Geweldige plek voor mij en mijn zoon. De barbers zijn vriendelijk, vakkundig en weten perfect hoe ze met kinderkapsels om moeten gaan."
}, {
  id: 5,
  name: "Lars K.",
  location: "Ouddorp",
  rating: 5,
  text: "Service van topniveau en een echt premium gevoel. Het online boeken maakt het erg makkelijk om een afspraak te plannen."
}];
export default function CustomerReviews() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: carouselRef,
    isVisible: isCarouselVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="ervaringen-van-de-man" className="dark bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold font-sans mb-6 tracking-normal uppercase">
            Echte Verhalen van <span className="text-primary">Onze Klanten</span> {}
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans leading-relaxed">
            Eerlijke beoordelingen die de kwaliteit, precisie en de gezellige sfeer in onze barbershop in Goeree-Overflakkee bevestigen. Sluit u aan bij meer dan 30.000 tevreden klanten.
          </p>
        </div>

        <div ref={carouselRef} className={`transition-all duration-1000 delay-200 ease-out ${isCarouselVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full relative">
            <CarouselContent className="-ml-4 md:-ml-6">
              {reviews.map((review, index) => <CarouselItem key={review.id} data-index={index} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                  <div className="h-full p-1">
                    <Card className="h-full bg-card/50 backdrop-blur-sm border-border/50 hover:border-primary/50 transition-colors duration-300 relative overflow-hidden group rounded-lg">
                      <div className="absolute -top-6 -right-6 text-primary/10 group-hover:text-primary/20 transition-colors duration-300">
                        <Quote className="w-32 h-32 rotate-12" />
                      </div>
                      <CardHeader className="pb-4 relative z-10">
                        <div className="flex items-center gap-1 mb-3">
                          {[...Array(review.rating)].map((_, i) => <Star key={i} data-index={i} className="w-5 h-5 fill-primary text-primary" />)}
                        </div>
                        <CardTitle className="text-xl font-bold font-sans text-foreground">
                          {review.name}
                        </CardTitle>
                        <CardDescription className="text-primary font-medium">
                          {review.location}
                        </CardDescription>
                      </CardHeader>
                      <CardContent className="relative z-10">
                        <p className="text-muted-foreground leading-relaxed font-sans">
                          "{review.text}"
                        </p>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="flex items-center justify-center gap-4 mt-12">
              <CarouselPrevious className="static translate-y-0 translate-x-0 bg-card border-border hover:bg-primary hover:text-primary-foreground transition-colors rounded-lg" />
              <CarouselNext className="static translate-y-0 translate-x-0 bg-card border-border hover:bg-primary hover:text-primary-foreground transition-colors rounded-lg" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}